import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './components/icon/icon.component';
import { HttpClientModule } from '@angular/common/http';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
@NgModule({
  declarations: [
    IconComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    SafeHtmlPipe
  ],
  exports: [
    IconComponent
  ],
  providers: [],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class IconsModule { }
